export  const taskStatusOptions =  [
  {
    label: '启动',
    value: '0'
  },
  {
    label: '执行中',
    value: '1'
  },
  {
    label: '成功',
    value: '2'
  },
  {
    label: '启动失败',
    value: '3'
  },
  {
    label: '队列中',
    value: '4'
  },
  {
    label: '未知',
    value: '5'
  },
  {
    label: '重复',
    value: '6'
  },
  {
    label: '手动停止任务',
    value: '7'
  },
  {
    label: '运行时间长',
    value: '8'
  },
  {
    label: '异常退出',
    value: '-3'
  },
  {
    label: '服务器繁忙',
    value: '-4'
  }
]
